var React = require('react');

function IconEmail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.5,9.75l8.693,5.36a8.915,8.915,0,0,0,9.357,0l8.693-5.36","transform":"translate(11.128 15.943)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3","key":0}),React.createElement("rect",{"width":"45.684","height":"33.684","rx":"3","transform":"translate(9 15)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M0,0H64V64H0Z","fill":"none","key":2})]);
}

IconEmail.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = IconEmail;

IconEmail.default = IconEmail;
